import React from 'react';

function Spacer(
    {
        height = 10,
        classname = ""
    }
) {

    return (
        <React.Fragment>
            {
                classname.length > 0 ?
                <div className={classname} />
                :
                <div style={{ height: height }} />
            }
            
        </React.Fragment>
    );
}

export default Spacer;
